import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginPartnerService } from '../partner/login-partner/login-partner.service';
import { MainService } from '../delavci/main.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardSharedServiceService  {

  constructor(private loginPartnerService: LoginPartnerService, private mainService: MainService,
              private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.loginPartnerService.currentPartnerValue) {
      if(this.loginPartnerService.currentPartnerValue.email == null || this.loginPartnerService.currentPartnerValue.id == null ||
        this.loginPartnerService.currentPartnerValue.sessionUser == null) {
       this.router.navigate(['/login-partner']);
       return false;
     } else {
       return true;
     }
    }
    if (this.mainService.currentUserValue) {
      if(this.mainService.currentUserValue.workerId == null || this.mainService.currentUserValue.userId == null ||
        this.mainService.currentUserValue.sessionUser == null) {
       this.router.navigate(['/login']);
       return false;
     } else {
       return true;
     }
    }
  this.router.navigate(['/login-partner']);
  return false;
  }
}
